import React, { memo } from "react";
import { theme } from "../../../theme";
import { formatMoney } from "../../../utils";

const CostBreakdown = memo(({ total_material_net_price }) => (
    <div className="card mb-3">
        <div className="card-body pb-0">
            <h6 className="mb-1 text-gradient text-dark">Cost Breakdown</h6>
            <div className="d-flex mt-1 ">
                <p className={`mb-0 text-gradient text-${theme.main} font-bold fw-bolder`}>Total Gross</p>
                <p className={`ms-auto text-gradient text-${theme.main} font-bold fw-bolder`}>
                    {formatMoney(total_material_net_price)}
                </p>
            </div>
        </div>
    </div>
));

export default CostBreakdown;